var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{attrs:{"color":_vm.theVal ? 'green' : 'red'}},[_vm._v("mdi-"+_vm._s(_vm.theVal ? _vm.trueIcon : _vm.falseIcon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }